import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type OverlayContainerProps = ComponentProps<'div'>;

export const OverlayContainer = memo(({ className, children, ...rest }: OverlayContainerProps) => (
  <div {...rest} className={cn('pointer-events-none fixed inset-0 z-portal flex size-full text-grey-12', className)}>
    {children}
  </div>
));

OverlayContainer.displayName = 'OverlayContainer';
